import React from 'react';

import fetch from './../fetch';

import reqwest from 'reqwest';


/**
 * 明细报表分析
 * @method list
 * @param {object} [keywords]
 * @return {promise}
 */
const list = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/list', Object.assign(defaultsParams, keywords))
}

/**
 * 学年汇总分析
 * @method list
 * @param {object} [keywords]
 * @return {promise}
 */
 const year = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/year', Object.assign(defaultsParams, keywords))
}


/**
 * 学期汇总分析
 * @method list
 * @param {object} [keywords]
 * @return {promise}
 */
 const term = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/term', Object.assign(defaultsParams, keywords))
}

/**
 * 多方汇总分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const multiple = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/multiple', Object.assign(defaultsParams, keywords))
}

/**
 * 检索教师/课程平均评价成绩
 * @method teacher
 * @param {object} [keywords]
 * @return {promise}
 */
 const mark = (keywords, param) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post(`eval/analysis/mark/${param}`, Object.assign(defaultsParams, keywords))
}

/**
 * 多条件组汇总分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const multipleConditions = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/multiple/conditions', Object.assign(defaultsParams, keywords))
}

/**
 * 正态数据检验分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const normalTest = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/normalTest', Object.assign(defaultsParams, keywords))
}


/**
 * 相关性分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const correlationAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/correlationAnalysis', Object.assign(defaultsParams, keywords))
}



/**
 * 数据分布分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const plotAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/plotAnalysis', Object.assign(defaultsParams, keywords))
}


/**
 * 相关性数据导出
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const exportCorrelation = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.download('eval/analysis/exportCorrelation', Object.assign(defaultsParams, keywords), "相关性分析.xls")
}

/**
 * 回归数据分布
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const plotRegression = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/plotRegression', Object.assign(defaultsParams, keywords))
}


/**
 * 回归数据导出
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const exportRegression = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.download('eval/analysis/exportRegression', Object.assign(defaultsParams, keywords), "回归分析数据分析.xls")
}

/**
 * 回归分析
 * @param {object} [keywords]
 * @return {promise}
 */
 const regressionAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/regressionAnalysis', Object.assign(defaultsParams, keywords))
}

/**
 * 多条件组回归分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const multipleRegressionAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/complexRegressionAnalysis', Object.assign(defaultsParams, keywords))
}


/**
 * 多组回归数据导出
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const multipleExportRegression = (keywords, name) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.download('eval/analysis/exportRegression', Object.assign(defaultsParams, keywords), `${name}.xls`)
}


/**
 * 评价人汇总分析
 * @method list
 * @param {object} [keywords]
 * @return {promise}
 */
 const listForEvaluator = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/listForEvaluator', Object.assign(defaultsParams, keywords))
}

/**
 * 明细汇总分析
 * @method list
 * @param {object} [keywords]
 * @return {promise}
 */
 const totalAnalysisForEvaluator = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/totalAnalysisForEvaluator', Object.assign(defaultsParams, keywords))
}




/**
 * 评价人个人测评数据分析
 * @method list
 * @param {object} [keywords]
 * @return {promise}
 */
 const listPersonalAnalysisForEvaluator = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/listPersonalAnalysisForEvaluator', Object.assign(defaultsParams, keywords))
}


/**
 * 被评价人/部门个人测评数据分析
 * @method list
 * @param {object} [keywords]
 * @return {promise}
 */
 const listEmployeeOrOrgAnalysisForEvaluator = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/analysis/listEmployeeOrOrgAnalysisForEvaluator', Object.assign(defaultsParams, keywords))
}


export default {
    list,
    year,
    multiple,
    term,
    mark,
    multipleConditions,
    normalTest,
    correlationAnalysis,
    plotAnalysis,
    exportCorrelation,
    plotRegression,
    exportRegression,
    regressionAnalysis,
    multipleRegressionAnalysis,
    multipleExportRegression,
    listForEvaluator,
    listPersonalAnalysisForEvaluator,
    totalAnalysisForEvaluator,
    listEmployeeOrOrgAnalysisForEvaluator

}